/* eslint-disable react/button-has-type,jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events,react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Space,
  Checkbox,
  Select,
  Spin,
  message,
  Modal,
  Form,
  Input,
} from "antd";
import { v4 as uuid } from "uuid";
import { Link, useHistory, useRouteMatch, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import axios from "axios";
import { find, isEmpty } from "lodash";
import moment from "moment";
import { fetchAgreementByAgrId } from "../../store/slices/agreements";
import { ReactComponent as SendIcon } from "../../img/send.svg";
import { ReactComponent as SaveIcon } from "../../img/save.svg";
import { ReactComponent as DeleteIcon } from "../../img/delete.svg";
import { ReactComponent as DotsIcon } from "../../img/3dots.svg";
import "./AccountBills.less";
import {
  displayFormat,
  toDisplayFormat,
  toDisplayFormatWithTime,
} from "../../lib/utils/formatDate";
import Message from "../Message/Message";
import { getBillsRoute } from "../../lib/routes/bills";
import HistoryAndPropertyModal from "../HistoryAndPropertyModal/HistoryAndPropertyModal";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import billStatusCodes from "../../lib/const/billStatusCodes";
import billTypeCodes from "../../lib/const/billTypeCodes";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ACCOUNT_BILLS_WRITE } from "../../lib/const/permissions";
import { setBillsFaximileWith } from "../../store/slices/settings";
import SpanNumberFormat from "../common/SpanNumberFormat";
import { ReactComponent as PrepaidBillIcon } from "../../img/payment_icons/prepaid-bill.svg";
import { ReactComponent as PostpaidBillIcon } from "../../img/payment_icons/postpaid-bill.svg";
import { ReactComponent as BillFactureIcon } from "../../img/payment_icons/bill-facture.svg";
import { ReactComponent as InvoiceIcon } from "../../img/payment_icons/invoice.svg";
import { round } from "../../lib/utils";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import { searchIconForInput } from "../../lib/icons";

export default function AccountBills(props) {
  const {
    bills,
    billsLoading,
    billStatus,
    billType,
    refetchBills,
    billsFilterValues,
    handleSetBillsFilterValues,
    billsPageNumber,
    setBillsPageNumber,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();

  const { accountEmails } = useSelector((state) => state.accounts);
  const { billsFaximileWith } = useSelector((state) => state.settings);
  const { agreements } = useSelector((state) => state.agreements);
  const { payStatus: payStatuses, serviceStatus } = useSelector((state) => state.rtkDictionaries);
  const { productsList, productsListLoading } = useSelector((state) => state.products);
  const { url } = useRouteMatch();
  const [visibleModal, setVisibleModal] = useState(false);
  const [objectId, setObjectId] = useState(null);
  const [objectDateFrom, setObjectDateFrom] = useState("");
  const [objectDateTo, setObjectDateTo] = useState("");
  const [filterBillsIdsForm] = Form.useForm();

  // При переходе из массовых платежей предустановка в фильтре номера договора, статусов "Не оплачен" и "Частично оплачен"
  useEffect(() => {
    if (search.includes("agreementId")) {
      const defaultAgreementId = search.replace("?agreementId=", "");
      handleSetBillsFilterValues({
        activeAgreementId: Number(defaultAgreementId),
        activePayStatusIds: [0, 1],
      });
    }
  }, [search]);

  let bData;

  if (checkIsLoaded(billsLoading)) {
    bData =
      bills &&
      bills
        .filter(({ agreementId }) =>
          billsFilterValues.activeAgreementId
            ? agreementId === billsFilterValues.activeAgreementId
            : true
        )
        .filter(({ billStatusId }) =>
          isEmpty(billsFilterValues.activeBillStatusIds)
            ? true
            : billsFilterValues.activeBillStatusIds.includes(billStatusId)
        )
        .filter(({ payStatusId }) =>
          isEmpty(billsFilterValues.activePayStatusIds)
            ? true
            : billsFilterValues.activePayStatusIds.includes(payStatusId)
        )
        .filter(({ servicePrepayments }) => {
          if (billsFilterValues.selectedServiceId) {
            return !!servicePrepayments.find(
              (product) => product.serviceId === billsFilterValues.selectedServiceId
            );
          }
          return true;
        })
        .filter(({ id }) => {
          if (billsFilterValues.activeIds.length === 0) {
            return true;
          }
          return billsFilterValues.activeIds.some((activeId) =>
            String(id).startsWith(String(activeId))
          );
        })
        .map((bill) => ({
          key: uuid(),
          id: bill.id,
          fromDate: bill.fromDate ? bill.fromDate : "",
          period: `${bill.periodFrom ? toDisplayFormat(bill.periodFrom) : ""} /\n${bill.periodTo ? toDisplayFormat(bill.periodTo) : ""
            }`,
          billNumber: bill.billNumber,
          amount: round(bill.amount),
          billStatusId: find(billStatus, { id: bill.billStatusId })?.name,
          billTypeId: find(billType, { id: bill.billTypeId })?.name,
          payStatus: find(payStatuses, { id: bill.payStatusId })?.name,
          amountLeft: round(bill.amountLeft),
          deliveryDate: bill.deliveryDate ? toDisplayFormatWithTime(bill.deliveryDate) : "",
          deleted: bill.billStatusId === billStatusCodes.deleted,
          agreementId: bill.agreementId,
          agreementNumber:
            agreements.find(({ id }) => id === bill?.agreementId)?.agreementNumber || "",
          fromDateForProperties: bill.fromDate,
          billTypeIdNumber: bill.billTypeId,
        }));
  }

  console.log({ bData });

  const downloadBill = async (id) => {
    try {
      const url = `${getBillsRoute()} / ${id} / download ? isEmpty = ${!billsFaximileWith} `;
      const { data } = await axios(url, {
        responseType: "blob",
      });
      saveAs(data, `bill${id}.pdf`);
    } catch (e) {
      Message("Ошибка загрузки счета", e);
    }
  };

  const sendBill = async (id) => {
    message.warning("Идет отправка счета...", 1e5);
    try {
      await axios.patch(`${getBillsRoute()}/${id}?isEmpty=${!billsFaximileWith}`);
      message.destroy();
      Modal.success({
        content: "Счет отправлен",
      });
      refetchBills();
    } catch (e) {
      message.destroy();
      Modal.error({
        content:
          "Ошибка отправки счета. Пожалуйста, повторите попытку позже или обратитесь к администратору",
      });
    }
  };

  const removeBill = async (id) => {
    try {
      await axios.delete(`${getBillsRoute()}/${id}?useCoveringVariant=3`);
      refetchBills();
    } catch (e) {
      if (e?.response?.data.message === "Нельзя удалять частично или полностью оплаченные счета") {
        Message(
          "Нельзя удалять частично или полностью оплаченные счета. Пожалуйста, снимите оплату со счета"
        );
      } else {
        Message("Ошибка при удалении счета", e);
      }
    }
  };

  const handleShowModal = (objId) => {
    setVisibleModal(true);
    setObjectDateFrom(objId.fromDateForProperties);
    setObjectDateTo(objId.toDate);
    setObjectId(objId.id);
  };

  const handleHideModal = () => {
    setVisibleModal(false);
    setObjectId(null);
  };

  const handleSelectBillStatus = (activeBillStatusIds) => {
    handleSetBillsFilterValues({ activeBillStatusIds });
  };

  const renderBillStatusIdTitle = () => (
    <Select
      onChange={handleSelectBillStatus}
      value={billsFilterValues.activeBillStatusIds}
      placeholder="Статус"
      style={{ width: "100%" }}
      allowClear
      maxTagCount={1}
      mode="multiple"
      showSearch
      filterOption={(inputValue, { children }) =>
        children.toLowerCase().includes(inputValue.toLowerCase())
      }
    >
      {billStatus.map(({ id, name }) => (
        <Select.Option key={uuid()} value={id}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );

  renderBillStatusIdTitle.toString = () => "Статус";

  const handleSelectAgreement = (activeAgreementId) => {
    if (search.includes("agreementId")) {
      // Если был переход из массовых платежей, удаляется из пути номер договора
      history.push(url);
    }
    handleSetBillsFilterValues({ activeAgreementId });
  };

  const renderAgreementColumnTitle = () => (
    <Select
      onChange={handleSelectAgreement}
      value={billsFilterValues.activeAgreementId}
      placeholder="Договор"
      style={{ width: "100%" }}
      allowClear
      showSearch
      filterOption={(inputValue, { children }) =>
        children.toLowerCase().includes(inputValue.toLowerCase())
      }
    >
      {agreements.map(({ id, agreementNumber }) => (
        <Select.Option key={uuid()} value={id}>
          {agreementNumber}
        </Select.Option>
      ))}
    </Select>
  );

  renderAgreementColumnTitle.toString = () => "Договор";

  const handleSelectPayStatus = (activePayStatusIds) => {
    if (search.includes("agreementId")) {
      // Если был переход из массовых платежей, удаляется из пути номер договора
      history.push(url);
    }
    handleSetBillsFilterValues({ activePayStatusIds });
  };

  const renderPayStatusColumnTitle = () => (
    <Select
      onChange={handleSelectPayStatus}
      value={billsFilterValues.activePayStatusIds}
      placeholder="Статус оплаты"
      style={{ width: "100%", maxWidth: "150px" }}
      maxTagCount={1}
      allowClear
      showSearch
      filterOption={(inputValue, { children }) =>
        children.toLowerCase().includes(inputValue.toLowerCase())
      }
      mode="multiple"
    >
      {payStatuses.map(({ id, name }) => (
        <Select.Option key={uuid()} value={id}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );

  renderPayStatusColumnTitle.toString = () => "Статус оплаты";

  const getGoalIcon = (goalTypeId) => {
    const icons = {
      1: [<PrepaidBillIcon key={uuid()} />, "Счет на предоплату"],
      2: [<PostpaidBillIcon key={uuid()} />, "Счет на постоплату"],
      3: [<BillFactureIcon key={uuid()} />, "Счет-фактура"],
      4: [<InvoiceIcon key={uuid()} />, "Инвойс"],
      // Временно добавлены для отображения значков (картинку нарисуют позже)
      5: [<InvoiceIcon key={uuid()} />, "Предложение"],
      6: [<InvoiceIcon key={uuid()} />, "Продукт"],
    };
    const [icon, title] = icons[goalTypeId];
    return (
      <div style={{ marginRight: "5px", width: "24px", height: "24px" }}>
        <Tooltip title={title}>{icon}</Tooltip>
      </div>
    );
  };

  const renderIdTitle = () => {
    const notValidRgx = /[^0-9,]/;
    let valueTrim = "";
    const onChangeId = ({ target: { value } }) => {
      valueTrim = value.replace(/^\s+/g, "");
      filterBillsIdsForm.setFieldsValue({ ids: valueTrim });
      if (!notValidRgx.test(value)) {
        const activeIds = valueTrim?.split(/\D/).filter(Boolean).map(Number);
        handleSetBillsFilterValues({ activeIds });
      }
    };

    return (
      <Tooltip title="Введите ID счетов через ','">
        <Form
          form={filterBillsIdsForm}
          initialValues={{
            ids: billsFilterValues.activeIds,
          }}
        >
          <Form.Item
            name="ids"
            style={{ marginBottom: 0 }}
            className="form-item-required__hidden-error__mb0"
            rules={[
              {
                validator: (x, value) => {
                  if (value && /[^0-9,]/.test(value)) {
                    return Promise.reject();
                  }
                  return Promise.resolve();
                },
                // message: "В качестве разделителя может использоваться только запятая",
              },
            ]}
          >
            <Input
              aria-autocomplete="none"
              placeholder="ID счетов"
              allowClear
              className="table-head-filter-search"
              suffix={searchIconForInput()}
              onChange={onChangeId}
            />
          </Form.Item>
        </Form>
      </Tooltip>
    );
  };

  renderIdTitle.toString = () => "ID счета";

  const getColumns = () => [
    {
      title: renderIdTitle,
      dataIndex: "id",
      key: "id",
      width: "7vw",
      render: (id) => (
        <span style={{ color: "rgba(0, 0, 0, 0.3)", fontWeight: "normal" }}>{id}</span>
      ),
    },
    {
      title: "Дата счета",
      dataIndex: "fromDate",
      key: "fromDate",
      defaultSortOrder: "descend",
      sorter: (a, b) => moment(a.fromDate).valueOf() - moment(b.fromDate).valueOf(),
      render: (value) => toDisplayFormat(value),
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (value) => <span className="account-bills__period">{value}</span>,
    },
    {
      title: "ID договора",
      dataIndex: "agreementId",
      key: "agreementId",
      width: "3vw",
      render: (agreementId) => (
        <span style={{ color: "rgba(0, 0, 0, 0.3)", fontWeight: "normal" }}>{agreementId}</span>
      ),
      hidden: true,
    },
    {
      title: renderAgreementColumnTitle,
      dataIndex: "agreementNumber",
      key: "agreementNumber",
      width: "100px",
    },
    {
      title: "Номер счета",
      dataIndex: "billNumber",
      key: "billNumber",
      render: (billNumber, record) => (
        <div style={{ display: "flex" }}>
          {getGoalIcon(record.billTypeIdNumber)}
          {billNumber}
        </div>
      ),
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (amount) => SpanNumberFormat({ amount }),
    },
    {
      title: renderBillStatusIdTitle,
      dataIndex: "billStatusId",
      key: "billStatusId",
    },
    {
      title: "Тип",
      dataIndex: "billTypeId",
      key: "billTypeId",
    },
    {
      title: renderPayStatusColumnTitle,
      dataIndex: "payStatus",
      key: "payStatus",
      width: "150px",
    },
    {
      title: "К оплате",
      dataIndex: "amountLeft",
      key: "amountLeft",
      render: (amountLeft) => SpanNumberFormat({ amount: amountLeft }),
    },
    {
      title: "Дата отправки",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
    },
    {
      dataIndex: "",
      key: "x",
      render: (record) => (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          {hasAccess(MENU_ACCOUNT_BILLS_WRITE) && (
            <>
              {record.amount !== "0.00" && (
                <>
                  <Popconfirm
                    title={
                      <>
                        <h3>Отправка счета по адресам</h3>
                        <ul className="list_unstyled account-bills__list-noPadding">
                          {accountEmails.map((item) => (
                            <li key={uuid()}>{item.email}</li>
                          ))}
                        </ul>
                      </>
                    }
                    placement="left"
                    okText="Отправить"
                    cancelText="Отмена"
                    icon=""
                    onCancel={(e) => e.stopPropagation()}
                    onConfirm={(e) => {
                      e.stopPropagation();
                      sendBill(record.id);
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <Button
                      icon={<SendIcon />}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className={record.deleted ? "account-bills__button-hide" : "button-icon"}
                    />
                  </Popconfirm>
                  <Button
                    icon={<SaveIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadBill(record.id);
                    }}
                    className="button-icon"
                  />
                </>
              )}
              {record?.billTypeIdNumber !== billTypeCodes.postPayment ? (
                <Popconfirm
                  title="Вы действительно хотите удалить счета?"
                  placement="left"
                  onCancel={(e) => e.stopPropagation()}
                  onConfirm={(e) => {
                    e.stopPropagation();
                    removeBill(record.id);
                  }}
                  okText="Да"
                  cancelText="Нет"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Button
                    icon={<DeleteIcon />}
                    disabled={record.sendable}
                    className={record.deleted ? "account-bills__button-hide" : "button-icon"}
                  />
                </Popconfirm>
              ) : (
                ""
              )}
            </>
          )}

          <Tooltip title="Показать историю" onClick={(e) => e.stopPropagation()}>
            <Button
              onClick={() => handleShowModal(record)}
              className="button-icon"
              style={{ outline: "none" }}
              disabled={record.sendable}
              icon={<DotsIcon />}
            />
          </Tooltip>
        </div>
      ),
      width: 100,
    },
  ];

  const [columns, setColumns] = useState(getColumns());

  // Обновление колонок загрузке справочников (для отображения фильтров в заголовках) с сохранением состояния hidden
  useEffect(() => {
    setColumns((prev) => {
      const newColumns = getColumns();
      const getNewColumn = ({ key }) => newColumns.find((item) => item.key === key);
      return prev.map((prevColumn) => {
        const newColumn = getNewColumn(prevColumn);
        return { ...prevColumn, title: newColumn.title, render: newColumn.render };
      });
    });
  }, [
    agreements,
    billStatus,
    payStatuses,
    billsFilterValues.activeAgreementId,
    billsFilterValues.activeBillStatusIds,
    billsFilterValues.activePayStatusIds,
    billsFaximileWith,
  ]);

  const onRow = (detail) => ({
    onClick: () => {
      history.push(`${url}/details/search?=${detail.id}`);
      dispatch(fetchAgreementByAgrId({ agreementId: detail?.agreementId }));
    },
  });

  const renderServiceSelect = () => {
    const isAgreementVisible = agreements?.length > 1;

    const getTooltipTitle = (item) => {
      const cellStyle = {
        border: `1px solid rgba(0, 0, 0, 0.1)`,
        padding: "5px",
        color: "rgba(0, 0, 0, 0.3)",
        backgroundColor: "white",
      };
      return (
        <div style={{ display: "flex" }}>
          {isAgreementVisible && (
            <div>
              <div style={cellStyle}>{item.agreement.agreementNumber}</div>
            </div>
          )}
          <div>
            <div style={cellStyle}>{item.serviceType?.name}</div>
          </div>
          <div>
            <div style={cellStyle}>{item.offering?.extName}</div>
          </div>
          <div>
            <div style={cellStyle}>{find(serviceStatus, { id: item.serviceStatusId })?.name}</div>
          </div>
          <div>
            <div style={cellStyle}>{moment(item.fromDate).format(displayFormat)}</div>
          </div>
          <div>
            <div style={cellStyle}>{moment(item.toDate).format(displayFormat)}</div>
          </div>
          <div>
            <div style={cellStyle}>{item.id}</div>
          </div>
        </div>
      );
    };

    const handleChangeBillsFaximileWith = () => {
      dispatch(setBillsFaximileWith(!billsFaximileWith));
    };

    const selectService = (id) => {
      handleSetBillsFilterValues({ selectedServiceId: id });
    };

    const toggleServicesIncludePastDates = (e) => {
      const { checked } = e.target;
      handleSetBillsFilterValues({ isServicesIncludePastDates: checked, selectedServiceId: null });
    };

    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Space>
          <Select
            value={billsFilterValues.selectedServiceId}
            onChange={selectService}
            style={{ width: "500px", marginRight: "30px", marginLeft: "8px" }}
            placeholder="Выбрать продукт"
            allowClear
            showSearch
            filterOption={(inputValue, { name }) =>
              name.toLowerCase().includes(inputValue.toLowerCase())
            }
          >
            {productsList &&
              productsList.length !== 0 &&
              productsList.map((product, idx) => {
                const valueForDisplay = isAgreementVisible
                  ? `${product.id} | ${product.agreement?.agreementNumber} | ${product.serviceType?.name} | ${product.offering?.extName}`
                  : `${product.id} | ${product.serviceType?.name} | ${product.offering?.extName}`;
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <Select.Option key={idx} value={product.id} name={valueForDisplay}>
                    <Tooltip
                      overlayInnerStyle={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        padding: "0",
                      }}
                      title={getTooltipTitle(product)}
                    >
                      <div>{valueForDisplay}</div>
                    </Tooltip>
                  </Select.Option>
                );
              })}
          </Select>
          <div style={{ width: "210px" }}>
            <Space>
              <Checkbox
                id="checkbox"
                onChange={toggleServicesIncludePastDates}
                checked={billsFilterValues.isServicesIncludePastDates}
              />
              <label htmlFor="checkbox" style={{ cursor: "pointer" }}>
                Показать закрытые продукты
              </label>
            </Space>
          </div>
        </Space>
        <Space>
          <Checkbox checked={billsFaximileWith} onChange={handleChangeBillsFaximileWith}>
            Счет с факсимиле
          </Checkbox>
        </Space>
      </div>
    );
  };

  return (
    <Spin spinning={!checkIsLoaded(productsListLoading) || !checkIsLoaded(billsLoading)}>
      <Row justify="space-between" align="middle">
        <Col>
          <h1>Счета</h1>
        </Col>
        {hasAccess(MENU_ACCOUNT_BILLS_WRITE) && (
          <Col>
            <Link to={`${url}/newInvoicing`}>
              <Button type="primary">Выставить счет</Button>
            </Link>
          </Col>
        )}
      </Row>
      {renderServiceSelect()}
      <Row justify="end">
        <ToggleColumns tableName="account-bills-table" columns={columns} setColumns={setColumns} />
      </Row>
      <Table
        columns={columns.filter(({ hidden }) => !hidden)}
        dataSource={bData}
        pagination={{
          position: ["bottomCenter"],
          hideOnSinglePage: true,
          current: billsPageNumber,
          onChange: setBillsPageNumber,
        }}
        size="small"
        onRow={onRow}
      />
      <HistoryAndPropertyModal
        objectTypeSysname="bill"
        objectId={objectId}
        handleHideModal={handleHideModal}
        visibleModal={visibleModal}
        dateObjectFromForCalendar={objectDateFrom}
        dateObjectToForCalendar={objectDateTo}
        hasAccessToEdit={hasAccess(MENU_ACCOUNT_BILLS_WRITE)}
      />
    </Spin>
  );
}
